import { Component, OnInit, OnDestroy } from '@angular/core';
import { BudgetService, SummaryBalanceData } from '../services/budget.service';
import { ActivatedRoute } from '@angular/router';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subscription } from 'rxjs/Subscription';
import { tap } from 'rxjs/operators';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-summary-balance',
  templateUrl: './summary-balance.component.html',
  styleUrls: ['./summary-balance.component.scss']
})
export class SummaryBalanceComponent implements OnInit, OnDestroy {

  constructor(private dataService: DataService,
    private budgetService: BudgetService, private route: ActivatedRoute) { }

  private subscription: Subscription;
  private _budgetId: string;

  private _summary: ReplaySubject<SummaryBalanceData> = new ReplaySubject(1);
  public ready = false;
  public budget$;

  get budgetId() {
    return this._budgetId;
  }

  get summary$() {
    return this._summary.asObservable();
  }


  ngOnInit() {

    this.budget$ = this.route.paramMap
    .switchMap((params) => {
      const budgetId = params.get('budgetId');
      return this.dataService.getSimpleBudget(budgetId);
    });

    const subscription =  this.route.paramMap
    .switchMap((params) => {
      this._budgetId = params.get('budgetId');
      return this.budgetService.getSummaryBalanceByBudget(this._budgetId);
    })
    .pipe(
      tap(() => {
        this.ready = true;
      })
    )
    .subscribe(this._summary);

  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


  compare(a: number, b: number) {
    return a > b;
  }

}



// WEBPACK FOOTER //
// ./src/app/balances/summary-balance.component.ts